// extracted by css-extract-rspack-plugin
export default {"prettifiedBlocksContainer":"PrettifiedBlocksList-module__prettifiedBlocksContainer__KtUqx"};